import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Crown, ShieldCheck, Sparkles } from 'lucide-react';
import { BOOK_PATH } from '../lib/routes';

const LOGO = "https://customer-assets.emergentagent.com/job_buraq-transport/artifacts/0a9wh5vw_0E081036-6309-4011-9127-0A9FE497D0F8.png";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden">
      <div className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-orange-600/15 blur-[120px]" />

      <div className="relative w-full max-w-3xl mx-auto px-5 lg:px-8 pb-16">
        <header className="flex items-center justify-between py-6 lg:py-8">
          <button
            data-testid="back-btn"
            onClick={() => navigate(-1)}
            className="w-11 h-11 rounded-full border border-white/10 flex items-center justify-center text-gray-300 hover:text-white hover:border-orange-500/40 active:scale-95 transition-all"
            aria-label="Back"
          >
            <ArrowLeft className="h-4 w-4" />
          </button>
          <button
            data-testid="logo-home"
            onClick={() => navigate('/')}
            className="flex items-center gap-2.5 active:scale-95 transition-transform"
            aria-label="Home"
          >
            <img src={LOGO} alt="RideBuraq" className="w-8 h-8 object-contain" />
            <span className="text-[11px] font-semibold tracking-[0.35em] text-gray-400 uppercase">RideBuraq</span>
          </button>
        </header>

        <div className="pt-4 pb-8">
          <p className="text-[11px] tracking-[0.3em] uppercase text-orange-400/80 mb-2">About Us</p>
          <h1 className="text-4xl lg:text-5xl font-semibold tracking-tight leading-none">The RideBuraq Story</h1>
        </div>

        <div className="space-y-5 text-gray-300 leading-relaxed">
          <p>
            RideBuraq is a premium private transportation service across New York, New Jersey and
            Connecticut — created for those who expect nothing less than exceptional. Every journey is
            chauffeured, discreet and effortless, from the moment you reserve to the moment you arrive.
          </p>
          <p>
            Our fleet is immaculate and our chauffeurs are professional, vetted and dedicated to your
            privacy, safety and comfort. Whether it's an airport transfer, a corporate event or a night
            out, we treat every mile as first class.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 mt-10">
          {[
            { icon: Crown, title: 'A Royal Fleet', text: 'Immaculate sedans and elite SUVs, maintained to a standard you feel instantly.' },
            { icon: ShieldCheck, title: 'Trusted & Discreet', text: 'Professional, vetted chauffeurs devoted to your privacy and comfort.' },
            { icon: Sparkles, title: 'Effortless', text: 'Reserve in seconds with transparent pricing and secure payment.' },
          ].map((f, i) => (
            <div key={i} className="rounded-2xl border border-white/10 bg-white/[0.02] p-5">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center mb-3">
                <f.icon className="h-5 w-5 text-white" />
              </div>
              <h3 className="font-semibold text-white mb-1">{f.title}</h3>
              <p className="text-sm text-gray-400">{f.text}</p>
            </div>
          ))}
        </div>

        <button
          data-testid="about-reserve-btn"
          onClick={() => navigate(BOOK_PATH)}
          className="mt-10 w-full sm:w-auto sm:px-16 mx-auto rounded-full py-4 text-base font-semibold text-white bg-gradient-to-r from-orange-500 to-orange-600 shadow-lg shadow-orange-900/30 hover:shadow-orange-500/30 active:scale-[0.99] transition-all flex items-center justify-center"
        >
          Reserve Your Ride
        </button>
      </div>
    </div>
  );
};

export default About;
